import { createFileRoute } from '@tanstack/react-router';

import config from '@@config';
import { requireRoles } from '@@router/guards';

export const Route = createFileRoute('/_authenticated/users')({
    beforeLoad: requireRoles(config.navigation.users.authorize),
});
